export default "__VITE_ASSET__DFOFD7e3__"